import ".././styles/AboutUs.css";
import ".././styles/CoreValues.css";

function CoreValues () {
  
    return(
        <div className="mission-body-text">
            <h3 className="section-padding">Integrity and Accountability</h3>
            <p className="paragraph">
                We strive to be effective in achieving our role and accountability to our members and stakeholders - the community,
                constituents, donors, board, staff, volunteers, collaborators, and all levels of government. We believe in modelling this trustworthiness
                and integrity that earns the public's high regard as a non-profit organization.
            </p>
            <h3 className="section-padding">Service and Responsible Stewardship</h3>
            <p className="paragraph">
                We are committed to a strong ethic of timely and reliable service to the community, and we strive to create
                an environment in which other organizations feel heard, safe, respected, and supported. More importantly,
                we are committed to careful stewardship of all human, natural, and financial resources and carefully use the time and talents of all members
                of our governing board and volunteers, and by wisely spending funds that accrue to the organization.
            </p>
        </div>
    );
}

export default CoreValues;